import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, onMounted } from 'vue';
import { DiscountInfo, InvoiceInfo, PriceInfo } from '@/services/billing-utils';
import { ProductType } from '@/api/api-billing';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceDetails',
  props: {
  invoiceInfo: { type: Object as PropType<InvoiceInfo>, required: true },
},
  setup(__props) {

const props = __props;



const discountInfo = computed(() => {
  const di = props.invoiceInfo?.discountInfo;
  if (!di || props.invoiceInfo.items.find(
    (ii) => ii.discountInfos.find(
      (iidi) => iidi.discount?.name === di.discount?.name,
    ),
  )) return undefined;
  return di;
});

const subscriptionPriceInfo = computed(() => {
  const items = props.invoiceInfo.items.toReversed();

  const index = items.findIndex(
    (i) => i.amountNumber > 0
    && i.priceInfo?.price?.product?.type === ProductType.Subscription
    && i.priceInfo.intervalPeriodically,
  );

  if (index < 0) return undefined;

  const priceInfo = { ...items[index].priceInfo };
  priceInfo.discountInfo = items[index].discountInfos.reduce(
    (odi, di) => ((di.discount?.discountAmount ?? 0) > (odi?.discount?.discountAmount ?? 0) ? di : odi),
    undefined as DiscountInfo | undefined,
  );

  console.log('subscriptionPriceInfo: ', priceInfo);
  return priceInfo;
});

onMounted(() => {
  console.log('invoice details mounted:', props.invoiceInfo, discountInfo.value, subscriptionPriceInfo.value);
});


return { __sfc: true,props, discountInfo, subscriptionPriceInfo }
}

})